import { gql } from "@apollo/client";

import { MEMBERSHIP_MANAGEMENT_FRAGMENT } from "../fragments";

// We need to find a way to test these fragments in isolation
export const GET_MEMBER_MANAGEMENT = gql`
  query getMyMembershipManagement {
    getMyMembershipManagement {
      id
      header
      membershipManagement {
        ...membershipManagement
      }
    }
  }
  ${MEMBERSHIP_MANAGEMENT_FRAGMENT}
`;
